const LAYOUT_TYPES = {
  VERTICAL: "vertical",
  HORIZONTAL: "horizontal",
}

const LAYOUT_MODE_TYPES = {
  LIGHTMODE: "light",
  DARKMODE: "dark",
  BRANDMODE: "brand",
}

const LAYOUT_SIDEBAR = {
  LIGHT: "light",
  DARK: "dark"
}

const LEFT_SIDEBAR_SIZE ={
  LARGE : "lg",
  MEDIUM : "md",
  SMALL : "sm",
  SMALLHOVER : "sm-hover"
}

const DATA_CARD_LAYOUT_TYPES = {
  BORDERLESS: "borderless",
  BORDER: "border",
}

const LAYOUT_WIDTH_TYPES = {
  FLUID: "fluid",
  BOXED: "boxed",
}

const LAYOUT_POSITION_TYPES = {
  FIXED: "fixed",
  SCROLLABLE: "scrollable",
}

const LAYOUT_TOPBAR_COLOR_TYPES = {
  LIGHT: "light",
  DARK: "dark",
  BRAND: "brand"
}

const LEFT_TOPBAR_IMAGE_TYPES = {
  ONE: "pattern-1",
  TWO: "pattern-2",
  THREE: "pattern-3",
};

const PERLOADER_TYPES = {
  ENABLE: "enable",
  DISABLE: "disable"
};


export {
  LAYOUT_TYPES,
  LAYOUT_MODE_TYPES,
  LAYOUT_SIDEBAR,
  LEFT_SIDEBAR_SIZE,
  DATA_CARD_LAYOUT_TYPES,
  LAYOUT_WIDTH_TYPES,
  LAYOUT_POSITION_TYPES,
  LAYOUT_TOPBAR_COLOR_TYPES,
  LEFT_TOPBAR_IMAGE_TYPES,
  PERLOADER_TYPES
}